import { IssueDto } from 'src/app/issues/models/issue';
import { ContributionDto, ContributionSourceTypes } from 'src/app/issues/models/contribution';

// A recurring alert mints a fresh alertId per firing, so fall back to the rule
// among live contributions (the list is already scoped to this asset).
export function matchIssue(issues: IssueDto[], alertId?: string, ruleId?: string): IssueDto | null {
  const live = (c: ContributionDto) => c.sourceType === ContributionSourceTypes.Alert && !c.closure?.reason;
  const contributions = (i: IssueDto) => i.contributions ?? [];
  return (alertId ? issues.find(i => contributions(i).some(c => live(c) && c.sourceRefAlertId === alertId)) : null)
    ?? (ruleId ? issues.find(i => contributions(i).some(c => live(c) && c.ruleId === ruleId)) : null)
    ?? null;
}
